import { FunctionField, FunctionFieldProps } from 'react-admin';
import Chip from '@mui/material/Chip';
import { makeStyles } from '@mui/styles';
import { resolvePath } from '@components';

const options = [
  { id: 'created', name: 'Created', color: '#36BE29' },
  { id: 'missing', name: 'Missing', color: '#a1a1a1' },
];

interface Props {
  autoWidth?: boolean;
  value?: string;
}

export const SyntageProfileField = (props: Props & Partial<FunctionFieldProps>) => {
  const cls = useStyles();
  const { autoWidth, ...restProps } = props;

  return (
    <FunctionField {...restProps} className={cls.chipWrap} render={(record: any) => {
      const profile = props.value
        || resolvePath(record, props.source || 'syntageProfile')
        || resolvePath(record, props.source || 'user.syntageProfile');
      const statusName = profile
        ? options.find(o => o.id === 'created')?.name
        : options.find(o => o.id === 'missing')?.name;
      const color: any = profile
        ? options.find(o => o.id === 'created')?.color
        : options.find(o => o.id === 'missing')?.color;

      return record && color ? (
        <Chip
          label={statusName}
          size="small"
          style={{
            backgroundColor: color ?? undefined,
            width: autoWidth ? 'auto' : '100%',
            padding: autoWidth ? '5px 15px' : undefined,
          }}
          className={cls.chip}
        />
      ) : null;
    }} />
  );
};

const useStyles = makeStyles({
  chip: {
    color: 'white !important',
    width: 'auto !important',
    lineHeight: 16,
    display: 'inline-flex',
    '& *': {
      color: 'white !important',
      lineHeight: 'normal',
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  chipWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
